<template>
   <div class="footerpage-style">
          <img src="@/assets/image/mobile/newhomepage/footerlogo.png" alt="">
          <div class="footerpage-info">
            <span>成都北鸣电子科技有限公司 
</span>
<span>备案编号：蜀ICP2023003901号</span>
          </div>
       
        </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .footerpage-style{
        // position: relative;
padding: 35px 20px;
display: flex;
flex-direction: column;
align-items: center;
// justify-content: center;
>img{
    width: 100px;
    height: auto;
}
.footerpage-info{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    >span{
        font-family: Source Han Sans CN;
font-weight: 400;
font-size: 0.8rem;
color: #333333;
    }
}

    }
</style>